<template>
    <div class="h-100">
        <div v-if="!value" class="d-flex flex-row step-card">
            <div class="row">
                <div class="col-md-6 pa-0 h-100">
                    <div class="d-flex flex-column justify-space-around h-100">
                        <p class="ma-0 fw-400 fs-18">
                            Enter your shopify store URL to integrate drop with shopify. You cannot change this URL later, so take care if it’s correct.
                        </p>
                        <primary-button @clickBtn="$emit('hideSteps'); $emit('redirect');" :activeButton="true">Connect</primary-button>
                    </div>
                </div>
                <div class="col-md-6 pa-0">
                    <v-img max-height="300px" max-width="100%" :src="$root.getSrc('/default/drop_icons/shopify_builder.svg')" contain></v-img>

                </div>
            </div>
        </div>
        <div class="d-flex align-center justify-center flex-column" style="height: 100%" v-else>
            <v-img max-height="96px" max-width="96px" :src="$root.getSrc('/default/drop_icons/tick.svg')" contain></v-img>
            <p class="ma-0 pt-5 fs-18 fw-400">
                Your shopify store <span class="fw-600">{{ $store.getters.activeWebsite.name }}</span> is connected to PrintDrop.
            </p>

            <secondary-button  class="pt-5" @clickBtn="$emit('hideSteps')" :activeButton="true">Close</secondary-button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value']
}
</script>
